import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable max-statements */
export var getHostDomain = function getHostDomain(hostname) {
  var hostnameParts = hostname === null || hostname === void 0 ? void 0 : hostname.split('.');
  var len = hostnameParts === null || hostnameParts === void 0 ? void 0 : hostnameParts.length;
  if (hostname !== null && hostname !== void 0 && hostname.endsWith('.co.uk')) {
    return hostnameParts === null || hostnameParts === void 0 ? void 0 : hostnameParts.splice(len - 3, 3).join('.');
  } else if (len > 2) {
    return hostnameParts === null || hostnameParts === void 0 ? void 0 : hostnameParts.splice(len - 2, 2).join('.');
  }
  return hostname;
};
export var initPx = function initPx(_ref) {
  var checkoutName = _ref.checkoutName,
    containerId = _ref.containerId,
    appKey = _ref.appKey;
  window.px = window.px || {};
  window.px.isLoadingAssets = false;
  window.px.buildAssets = window.px.buildAssets || {};
  window.px.getClientFiles = function getClientFiles(chunkName) {
    return window.px.buildAssets[chunkName] || chunkName;
  };
  window.px[checkoutName] = window.px[checkoutName] || {};
  window.px[checkoutName].loader = {
    appKey: appKey,
    checkoutName: checkoutName,
    component: '@px/checkouts',
    containerId: containerId
  };
};
export var prefetchLaunch = function prefetchLaunch(_ref2) {
  var _window$document, _window$document$docu, _window$document2, _window$document2$doc, _window$screen, _window$screen2, _Math$random;
  var _ref2$checkoutName = _ref2.checkoutName,
    checkoutName = _ref2$checkoutName === void 0 ? 'ExpressCart' : _ref2$checkoutName,
    appKey = _ref2.appKey,
    basketId = _ref2.basketId,
    products = _ref2.products;
  var urlParams = new URLSearchParams();
  var body = {
    browserInfo: {
      clientWidth: (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.clientWidth,
      clientHeight: (_window$document2 = window.document) === null || _window$document2 === void 0 ? void 0 : (_window$document2$doc = _window$document2.documentElement) === null || _window$document2$doc === void 0 ? void 0 : _window$document2$doc.clientHeight,
      screenHeight: (_window$screen = window.screen) === null || _window$screen === void 0 ? void 0 : _window$screen.height,
      screenWidth: (_window$screen2 = window.screen) === null || _window$screen2 === void 0 ? void 0 : _window$screen2.width,
      timeZone: new Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  };
  if (products) {
    body.products = products;
  }
  if (basketId) {
    urlParams.append('basketId', basketId);
  }
  var url = "https://cart.".concat(getHostDomain(window.location.hostname), "/checkoutapi/v1/checkouts/").concat(checkoutName, "/launch?").concat(urlParams.toString());
  var options = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(body)
  };
  if (appKey) {
    options.headers['x-app-key'] = appKey;
  }
  var prefetchId = (_Math$random = Math.random()) === null || _Math$random === void 0 ? void 0 : _Math$random.toString();
  window.px = window.px || {};
  window.px[checkoutName] = window.px[checkoutName] || {};
  window.px[checkoutName].prefetchId = prefetchId;
  window.px["launch-".concat(prefetchId)] = fetch(url, options);
  return prefetchId;
};
export var loadScript = function loadScript(id, url, callback) {
  var body = document.getElementsByTagName('body')[0];
  var script = document.createElement('script');
  script.id = id;
  script.type = 'text/javascript';
  script.src = url;
  script.async = false;
  script.crossOrigin = 'anonymous';
  script.onload = callback;
  body.appendChild(script);
};
export var preloadAssets = function preloadAssets(buildAssets) {
  var _window$px;
  if (buildAssets && ((_window$px = window.px) === null || _window$px === void 0 ? void 0 : _window$px.assetsPreloaded) !== true) {
    Object.keys(buildAssets).forEach(function (i) {
      if (buildAssets[i].indexOf('.js.map') === -1 && buildAssets[i].indexOf('.txt') === -1) {
        var preloadLink = document.createElement('link');
        preloadLink.href = buildAssets[i];
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        window.px = window.px || {};
        window.px.assetsPreloaded = true;
      }
    });
  }
};
var updateIsCheckoutReady = function updateIsCheckoutReady(checkoutName) {
  window.px = window.px || {};
  window.px[checkoutName] = window.px[checkoutName] || {};
  window.px[checkoutName].isCheckoutReady = true;
};

// eslint-disable-next-line max-statements
export var loadAssets = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3, intervalId) {
    var _window$px2, _window$px$checkoutNa;
    var appKey, assets, _ref3$checkoutName, checkoutName, onError, preload, assetsSha, assetsExist, _window$px3, url, options, res, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          appKey = _ref3.appKey, assets = _ref3.assets, _ref3$checkoutName = _ref3.checkoutName, checkoutName = _ref3$checkoutName === void 0 ? 'ExpressCart' : _ref3$checkoutName, onError = _ref3.onError, preload = _ref3.preload;
          assetsSha = assets && assets !== null && assets !== void 0 && assets.length ? "/".concat(assets) : '';
          assetsExist = Object.keys((_window$px2 = window.px) === null || _window$px2 === void 0 ? void 0 : _window$px2.buildAssets).length;
          if (assetsExist && preload) {
            preloadAssets((_window$px3 = window.px) === null || _window$px3 === void 0 ? void 0 : _window$px3.buildAssets);
          }
          if (!(!assetsExist && !window.px.isLoadingAssets)) {
            _context.next = 31;
            break;
          }
          window.px.isLoadingAssets = true;
          url = "https://cart.".concat(getHostDomain(window.location.hostname), "/checkoutapi/v1/checkouts/").concat(checkoutName, "/assets").concat(assetsSha);
          options = {
            method: 'POST',
            credentials: 'include',
            headers: {
              'x-app-key': appKey
            }
          };
          _context.prev = 8;
          if (!window.px.assetsLoader) {
            window.px.assetsLoader = fetch(url, options);
          }
          _context.next = 12;
          return window.px.assetsLoader;
        case 12:
          res = _context.sent;
          _context.next = 15;
          return res.clone().json();
        case 15:
          data = _context.sent;
          window.px.assetGroup = data === null || data === void 0 ? void 0 : data.version;
          window.px.isLoadingAssets = false;
          window.px.buildAssets = data === null || data === void 0 ? void 0 : data.buildAssets;
          window.px.entries = data === null || data === void 0 ? void 0 : data.entries;
          preload && preloadAssets(data === null || data === void 0 ? void 0 : data.buildAssets);
          loadScript(checkoutName, data === null || data === void 0 ? void 0 : data.entries[checkoutName], function () {
            return updateIsCheckoutReady(checkoutName);
          });
          _context.next = 29;
          break;
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](8);
          intervalId && clearInterval(intervalId);
          onError && onError(_context.t0);
          delete window.px.assetsLoader;
        case 29:
          _context.next = 32;
          break;
        case 31:
          if (assetsExist && window.px.entries && !((_window$px$checkoutNa = window.px[checkoutName]) !== null && _window$px$checkoutNa !== void 0 && _window$px$checkoutNa.isCheckoutReady)) {
            loadScript(checkoutName, window.px.entries[checkoutName], function () {
              return updateIsCheckoutReady(checkoutName);
            });
          }
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 24]]);
  }));
  return function loadAssets(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
//# sourceMappingURL=utils.js.map